import { StateManager } from '../state-manager'
import { TYPES } from '../../types'
import { Inject } from '../../domain/di/inject'
import { Location } from '../../domain/location/location'
import { Injectable } from '../../domain/di/injectable'
import { Query } from '../../domain/use-cases/query'
import { LocationRepository } from '../../domain/location/location-repository'

@Injectable()
export class GetLocationsQry extends Query<Location[]> {
  constructor(
    @Inject(TYPES.STATE_MANAGER) private readonly stateManager: StateManager,
    @Inject(TYPES.LOCATION_REPOSITORY) private readonly locationRepository: LocationRepository
  ) {
    super()
  }

  internalExecute(): Location[] {
    if (this.stateManager.state.locations.length === 0) {
      this.locationRepository.findAll().then(locations=>{
          this.stateManager.patch({ locations: locations })
      })
    }
    return this.stateManager.state.locations
  }
}
